/**
 * Generated from ch1_p06.fla
 */
export function ch1_p06(this: Ich1_p06) {
	const board = this.board;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundboard.call(this.board);
	board.x = 0;
	board.y = 0;
	board.width = 1664.00;
	board.height = 768.00;
	board.alpha = 1.00;
	if (board.onLayout) board.onLayout();
	const stickers = this.stickers;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundstickersandpostcards.call(this.stickers);
	stickers.x = 0;
	stickers.y = 0;
	stickers.width = 1664.00;
	stickers.height = 768.00;
	stickers.alpha = 1.00;
	if (stickers.onLayout) stickers.onLayout();
	const papers = this.papers;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_papers.call(this.papers);
	papers.x = 797.75;
	papers.y = 384;
	papers.width = 1595.50;
	papers.height = 768.00;
	papers.alpha = 1.00;
	if (papers.onLayout) papers.onLayout();
	const cal = this.cal;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cal.call(this.cal);
	cal.x = 828.75;
	cal.y = 404;
	cal.width = 668.50;
	cal.height = 650.00;
	cal.alpha = 1.00;
	if (cal.onLayout) cal.onLayout();
	const circle = this.circle;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_circle.call(this.circle);
	circle.x = 900.75;
	circle.y = 477;
	circle.width = 250.50;
	circle.height = 239.00;
	circle.alpha = 1.00;
	if (circle.onLayout) circle.onLayout();
	const cake = this.cake;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cake.call(this.cake);
	cake.x = 918.5;
	cake.y = 489.25;
	cake.width = 127.00;
	cake.height = 130.50;
	cake.alpha = 1.00;
	if (cake.onLayout) cake.onLayout();
	const calCord = this.calCord;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calcord.call(this.calCord);
	calCord.x = 807.5;
	calCord.y = 80.25;
	calCord.width = 29.00;
	calCord.height = 53.50;
	calCord.alpha = 0.71;
	if (calCord.onLayout) calCord.onLayout();
	const calPin = this.calPin;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calpin.call(this.calPin);
	calPin.x = 814.75;
	calPin.y = 48.5;
	calPin.width = 63.50;
	calPin.height = 76.00;
	calPin.alpha = 1.00;
	if (calPin.onLayout) calPin.onLayout();
	const frame = this.frame;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframech1_p6_wcframe.call(this.frame);
	frame.x = 832;
	frame.y = 384;
	frame.width = 1664.00;
	frame.height = 768.00;
	frame.alpha = 1.00;
	if (frame.onLayout) frame.onLayout();
	const frameCorner = this.frameCorner;
	ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframeLayer48.call(this.frameCorner);
	frameCorner.x = 64.75;
	frameCorner.y = 664.75;
	frameCorner.width = 129.50;
	frameCorner.height = 206.50;
	frameCorner.alpha = 1.00;
	if (frameCorner.onLayout) frameCorner.onLayout();
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundboard(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundboard) {
	if (this.setLayoutTexture) this.setLayoutTexture("board.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundstickersandpostcards(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundstickersandpostcards) {
	if (this.setLayoutTexture) this.setLayoutTexture("stickersandpostcards.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_papers(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_papers) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p06_papers", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cal(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cal) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p06_cal", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_circle(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_circle) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p06_circle", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cake(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cake) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p06_cake", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calcord(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calcord) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p06_calcord", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calpin(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calpin) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p06_calpin", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframech1_p6_wcframe(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframech1_p6_wcframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p6_wcframe", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframeLayer48(this: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframeLayer48) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer48", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p06Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p06Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p06Sprite extends Ich1_p06Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p06Text extends Ich1_p06Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p06Polygon extends Array<number> {
}
interface Ich1_p06 {
	readonly board: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundboard;
	readonly stickers: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundstickersandpostcards;
	readonly papers: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_papers;
	readonly cal: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cal;
	readonly circle: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_circle;
	readonly cake: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cake;
	readonly calCord: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calcord;
	readonly calPin: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calpin;
	readonly frame: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframech1_p6_wcframe;
	readonly frameCorner: Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframeLayer48;
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundboard extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_backgroundstickersandpostcards extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_papers extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cal extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_circle extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_cake extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calcord extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_calpin extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframech1_p6_wcframe extends Ich1_p06Sprite {
}
interface Ich1_p06_hh_ch1_72dpi_p06psdAssetP6ch1_p06_wcframeLayer48 extends Ich1_p06Sprite {
}
